<template>
  <vs-dropdown
    vs-custom-content
    vs-trigger-click
    class="cursor-pointer"
    :class="this.verticalNavMenuWidth === 'default' ? 'sm:mr-6 mr-2' : 'mr-2'"
  >
    <span class="cursor-pointer flex items-center i18n-locale p-2 font-bold" style="border-radius: 8px; border: 1px solid #7367F0; color:#7367F0; ">
      <feather-icon icon="GlobeIcon" class="w-5 h-5" />
      <span class="block ml-2">{{ getCurrentLocaleData.name }}</span>
    </span>
    <vs-dropdown-menu class="w-64 i18n-dropdown vx-navbar-dropdown" style="z-index: 530001;">
      <div class="border-bottom pb-3">
        <p class="px-4 py-2 text-md font-medium" style="color:#696D71;">{{ $t('현재 언어') }}</p>
        <p class="px-4 py-2 text-xl font-bold" style="color:#1E0D61">{{ getCurrentLocaleData.name }}</p>
      </div>
      <vs-dropdown-item v-for="locale in locales" @click="updateLocale(locale)" class="px-0 py-1 text-lg " style="color:#1D1D1D; font-weight: 700;">{{ locale.name }}</vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  computed: {
    getCurrentLocaleData () {
      const locale = this.$i18n.locale

      return this.getLocaleData(locale)
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
  },
  data () {
    return {
      locales: [
        { name: '한국어', lang: 'ko_KR' },                             // Korean
        { name: 'বাংলা(방글라데시)', lang: 'bn_BD' },                  // Bengali
        { name: 'English(영어)', lang: 'en_US' },                     // English
        { name: 'Filipino(필리핀)', lang: 'fil_PH' },                 // Filipino
        { name: 'Français(프랑스어)', lang: 'fr_FR' },                 // French
        { name: 'हिन्दी(인도)', lang: 'hi_IN' },                        // Hindi (※ 인도 추가)
        { name: 'Bahasa Indonesia(인도네시아어)', lang: 'id_ID' },     // Indonesian
        { name: '日本語(일본어)', lang: 'ja_JP' },                      // Japanese
        { name: 'ភាសាខ្មែរ(캄보디아)', lang: 'km_KH' },                // Khmer
        { name: 'Кыргызча(키르기스어)', lang: 'ky_KG' },               // Kyrgyz
        { name: 'ລາວ(라오스)', lang: 'lo_LA' },                        // Lao
        { name: 'Bahasa Melayu(말레이시아)', lang: 'ms_MY' },          // Malay
        { name: 'Монгол(몽골어)', lang: 'mn_MN' },                      // Mongolian
        { name: 'မြန်မာ(미얀마)', lang: 'my_MM' },                     // Burmese
        { name: 'नेपाली(네팔어)', lang: 'ne_NP' },                     // Nepali
        { name: 'Português(동티모르)', lang: 'pt_TL' },                // Portuguese (East Timor)
        { name: 'Русский(러시아)', lang: 'ru_UZ' },               // Russian (※ 우즈벡에서 자주 사용)
        { name: 'සිංහල(스리랑카)', lang: 'si_LK' },                    // Sinhala
        { name: 'தமிழ்(스리랑카)', lang: 'ta_LK' },                    // Tamil (Sri Lanka)
        { name: 'Türkçe(투르크멘어)', lang: 'tk_TM' },                  // Turkmen
        { name: 'Tiếng Việt(베트남어)', lang: 'vi_VN' },               // Vietnamese
        { name: 'Oʻzbekcha(우즈베크어)', lang: 'uz_UZ' },              // Uzbek
        { name: 'اردو(파키스탄)', lang: 'ur_PK' },                     // Urdu
        { name: '简体中文(중국어간체)', lang: 'zh_CN' },                 // Simplified Chinese
        { name: '繁體中文(중국어번체)', lang: 'zh_TW' },                 // Traditional Chinese
        { name: 'ไทย(태국어)', lang: 'th_TH' }                         // Thai
      ]
    }
  },
  methods: {
    getLocaleData (locale) {
      return this.locales.find(item => item.lang === locale) || { name: '한국어', lang: 'ko-KR' }
    },
    updateLocale (locale) {
      this.$i18n.locale = locale.lang
      localStorage.setItem('locale', locale.lang)
    }
  }
}
</script>
